import React, { useEffect } from 'react';
import { Layout } from '@lana-ui/common';
import { Button } from '@lana-ui/login';
import HeaderLogin from '../headerLogin/HeaderLogin';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './login-layout.scss';
import RightContentHeader from '../../../../Layout/RightContentHeader';
import EmbedHide from '../../../Organism/EmbedHide';

const propTypes = {
    /**
     * Clases adicionales.
     */
    className: PropTypes.string,
};

const LoginLayout = ({ darkMode, black, showArrowBack, children, className, blackFooter }) => {
    const classes = classNames('lgn-layout', className, {
        '--black': black,
    });

    useEffect(() => {
        const body = document.querySelector('body');
        if (!black) {
            const script = document.createElement('script');

            script.src = 'https://api.wcx.cloud/widget/?id=35bfef27b1074750908a67ae7494f690';
            script.async = true;
        } else {
            return;
        }
    }, []);

    return (
        <>
            <Layout className={classes} black={black} darkMode={darkMode}>
                <EmbedHide>
                    <HeaderLogin black={black} darkMode={darkMode} showArrowBack={showArrowBack} rightContent={<RightContentHeader />} />
                </EmbedHide>

                <Layout as="section" type="wrapped-extra-small">
                    <div className="WithoutHeaderSuscription">
                        {children}
                    </div>
                </Layout>
            </Layout>
        </>
    );
};

LoginLayout.propTypes = propTypes;

export default LoginLayout;
